import axios from '../../config/axiosClient';
import Config from '../../config/Config.js'

export const FETCH_USER = (username) => {
    return axios
        .get(
            `${Config().userUrl}?username=${username.toLowerCase()}`
        )
        .then(res => {
            const data = res.data;
            return Array.isArray(data) ? data[0] : data.results?.[0]
        })
        .catch(err => {
            console.error('FETCH_USER Error:', err);
            throw err;
        });
};

export const FETCH_EXTENDED_USER = (user_id) => {
    return axios
        .get(
            `${Config().extendedUserUrl}?user=${user_id}`
        )
        .then(res => {
            const data = res.data;
            const results = Array.isArray(data) ? data : data.results || [];
            return results[0] || null;
        })
        .catch(err => {
            console.error('FETCH_EXTENDED_USER Error:', err);
            return null;
        });
}

export const FETCH_PROJECTS = (id, publish) => {
    return axios
        .get(`${Config().baseUrl}?owner=${id}&publish=${publish}`)
        .then(res => {
            const data = res.data;
            return Array.isArray(data) ? data : data.results || []
        })
        .catch(err => {
            console.error('FETCH_PROJECTS Error:', err);
            throw err;
        });
}